// The scenario a page belongs to is encoded in the path itself, so several
// places need the same reading of `window.location.pathname`.

export function getPathSegments(): string[] {
  return window.location.pathname.split('/').slice(1)
}

export function getFirstPathSegment(): string {
  return getPathSegments()[0] ?? ''
}
